import React, {Component, Fragment} from "react";
import Graph from "../../../../etc/Graph";
import * as func from "../../../../../utils/functions";
import {NavLink} from "react-router-dom";
import Dropdown from "../../../../etc/dropdown";
import {JOURNAL_ORDER_BY_OPTIONS, ORDER, RECORD_PER_PAGES, BASE_PATH} from "../../../../../wpconfig/";
import {pushUrl} from "../../../../../utils/functions";
import ResourceItem from "../../../../resource/front/list/Resourceitem";

class JAlticle extends Component {
	constructor(props) {
		super(props);

		this.state = {
			param : {
				"journal_id": [this.props.record.journal_id],
				// "collabo_org" : ["부산대학교"],
				'order_by' : 'date',
				'order' : 'desc',
				'record_per_page' : 5,
				'current_page' : 1
			},
			records: [],
			totalRecords : 0
		}

		const param = this.state.param;
		func.getData("resources", param).then((response) => {
			this.setState({'records' : response.records, totalRecords: response.pageInfo.totalResults})
		});
	}

	paramEvnet = (name, value) => {
		let param = this.state.param;
		param[name] = value;

		this.setState({"param": param})
		func.getData("resources", this.state.param).then((response) => {
			this.setState({'records' : response.records, totalRecords: response.pageInfo.totalResults})
		});
	}

	render() {
		if(this.state.records.length <= 0)
			return '';
		return (
			<div className="mt-65 journal-detail-article">
				<div className="d-flex justify-content-between align-items-center mb-px-26">
					<div className="d-flex align-items-center">
						<h3 className="con-title">우리 대학 연구자의 논문</h3>
					</div>
					<div className="d-flex align-items-center">
						<Dropdown options={JOURNAL_ORDER_BY_OPTIONS} value={this.state.param.order_by} onChange={this.paramEvnet} name="order_by" />
					</div>
				</div>
				<div>
					<div className="line-list-group">
						{this.state.records.map((record, index) => {
							return (
								<ResourceItem key={index} record={record}/>
							)
						})}
					</div>
				</div>
				{this.state.totalRecords > 5 &&
				<div className="mt-4">
					<div className="text-center">
						{/*<button className="btn btn-outline-gray btn-lg"><span className="icon icon-size-24 icon-plus-black align-top mr-2" />*/}
						<NavLink to={BASE_PATH + 'resources/?journal_id[]=' + this.props.record.journal_id}
						         className="btn btn-outline-gray btn-lg">
							<span className="icon icon-size-24 icon-plus-black align-top mr-2"/><strong>논문 더보기</strong>
						</NavLink>
						{/*</button>*/}
					</div>
				</div>
				}
			</div>
		);
	}
};

export default JAlticle;
